import React from "react";
import { cn } from "../../utils/lib";

export function PriceIconSelected({ className, ...props }) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      className={cn("w-full h-auto", className)}
      {...props}
    >
      <path
        opacity="0.4"
        d="M3.47483 12.7492L7.24983 16.5242C8.79983 18.0742 11.3165 18.0742 12.8748 16.5242L16.5332 12.8659C18.0832 11.3159 18.0832 8.79919 16.5332 7.24085L12.7498 3.47419C11.9582 2.68252 10.8665 2.25752 9.74983 2.31585L5.58316 2.51585C3.9165 2.59085 2.5915 3.91585 2.50816 5.57419L2.30816 9.74085C2.25816 10.8659 2.68316 11.9575 3.47483 12.7492Z"
        fill="white"
      />
      <path
        d="M7.9166 10.3176C9.24208 10.3176 10.3166 9.24306 10.3166 7.91758C10.3166 6.59209 9.24208 5.51758 7.9166 5.51758C6.59112 5.51758 5.5166 6.59209 5.5166 7.91758C5.5166 9.24306 6.59112 10.3176 7.9166 10.3176Z"
        fill="white"
      />
    </svg>
  );
}
